<mojo-activity-recorder></mojo-activity-recorder>
<mojo-desktop-alert></mojo-desktop-alert>
<mojo-brand-css-loader brandLinkId="brand-style"></mojo-brand-css-loader>
<div class="main-container">
  <mojo-viewbar></mojo-viewbar>
  <lister-page-title *ngIf="(routeContextTypeName$ | async) === 'ListerRouteContext'"></lister-page-title>
  <mojo-page-title *ngIf="(routeContextTypeName$ | async) === 'DashboardRouteContext'"
                   [title]="dashboardTitle$ | async"
                   [ref]="ref$ | async"></mojo-page-title>
  <mojo-overview *ngIf="(maximisedWidget$ | async) === undefined"></mojo-overview>
  <router-outlet></router-outlet>
</div>
